import z from 'zod';

/**
 * Firestore representation of a user-selected module.
 * For now we only persist the exam module id.
 */
export const userModuleDbSchema = z.object({
  moduleId: z.string(),
  /** Selected topic names from ModuleTopic.topic (optional for backward compatibility). */
  topics: z.array(z.string()).optional(),
});

export type UserModuleDb = z.infer<typeof userModuleDbSchema>;
